import {
  IconWarning,
  colors,
  getBorderRadius,
  getFontStyle,
  spacing,
} from '@cabonline/ui-shared';
import { StyledRequired } from '../form/form-item/styles';
import styled from '@emotion/styled';
import { FC, InputHTMLAttributes } from 'react';
import { Label } from '../label';

const labelHeight = `${spacing.m}px`;

const Container = styled.div``;

const ErrorWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${labelHeight};
  margin-bottom: 4px;
`;

const ErrorText = styled.div`
  ${getFontStyle('s', 'semi')};
  color: ${colors.red};
  padding-left: 4px;
`;

interface StyledInputProps {
  fullWidth: boolean;
  hasError?: boolean;
}

const StyledInput = styled.input<StyledInputProps>`
  height: ${spacing.xl}px;
  border-radius: ${getBorderRadius('s')};
  width: ${(p) => (p.fullWidth ? '100%' : '180px')};
  padding: ${spacing.xs}px;
  border: 1px solid ${(props) => (props.hasError ? colors.red : colors.gray2)};
  ${getFontStyle('m', 'semi')};

  &:disabled {
    background-color: ${colors.gray3};
    cursor: not-allowed;
  }
  &::-webkit-calendar-picker-indicator {
    font-size: 24px;
  }
`;

interface TimeInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  isRequired?: boolean;
  fullWidth?: boolean;
  hasError?: boolean | string;
  testID?: string;
}

export const TimeInput: FC<TimeInputProps> = ({
  value,
  onChange,
  label,
  isRequired,
  id,
  fullWidth = false,
  hasError,
  testID = '',
  ...rest
}) => (
  <Container>
    {label && (
      <Label htmlFor={id}>
        {label}
        {isRequired && <StyledRequired aria-hidden />}
      </Label>
    )}
    {hasError && typeof hasError === 'string' && (
      <ErrorWrap>
        <IconWarning color={colors.red} />
        <ErrorText>{hasError}</ErrorText>
      </ErrorWrap>
    )}
    <StyledInput
      type="time"
      onChange={onChange}
      value={value}
      fullWidth={fullWidth}
      hasError={Boolean(hasError)}
      data-testid={testID}
      {...rest}
    />
  </Container>
);
